
import React from "react";
import { easeInOut, motion } from "framer-motion"; 
import { useLanguage } from "../../../../contexts/LanguageContext"; 
import ImageOne from "../../../../assets/images/services-images-one.png";
import ImageTwo from "../../../../assets/images/services-images-two.png";
import { servicesVivaa } from "../../../../utils/translations";
import "./services.css"; 

export default function Services() {
  const { language } = useLanguage(); 

  return (
    <div className={`services ${language === "ar" ? "rtl" : ""} ${language === "ar" ? "arab" : ""}`}>
      <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
        <hr style={{ width: "50%", borderTop: "1px solid var(--secondary-color)" }} />
      </div>

      <h2 className={`services-title ${language === "ar" ? "arabic" : ""}`}>
        {servicesVivaa[language].title}
      </h2>

      <motion.div
        className="services-section"
        initial={{ opacity: 0, y: 100 }} 
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{duration : 1 , ease : easeInOut}}
      >

        <div key="service1" className="services-item">
          <img src={ImageTwo} alt="Gift wrapping service" />
          <div className="services-text">
            <h2 className="services-itemTitle">{servicesVivaa[language].madeYourGift}</h2>
            <p>{servicesVivaa[language].description1}</p>
            <p>{servicesVivaa[language].description2}</p>
            <p>{servicesVivaa[language].description3}</p>
            <p>{servicesVivaa[language].description4}</p>
          </div>
        </div>

        <div key="service2" className="services-item">
          <img src={ImageOne} alt="Personalized video messages" />
          <div className="services-text">
            <h2 className="services-itemTitle">{servicesVivaa[language].celebrityVideo}</h2>
            <h2 className="services-itemTitle">{servicesVivaa[language].message}</h2>
            <p>{servicesVivaa[language].description5}</p>
            <p>{servicesVivaa[language].description6}</p>
            <p>{servicesVivaa[language].description7}</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}